<template>
  <div>
    <div class="top-img">
      <img src="@/assets/contactpic/top-img.jpg" alt="Top Image" />
    </div>
    <div class="aboutexhibit-title-top"></div>
    <div class="aboutexhibit-title-text">
      <h1>{{ $t("contactMapTitle") }}</h1>
    </div>
    <ContactMap></ContactMap>
    <ContactCenter></ContactCenter>
    <ContactUs></ContactUs>
    <ContactDown></ContactDown>
  </div>
</template>

<script>
import ContactMap from "./contactItem/ContactMap.vue";
import ContactCenter from "./contactItem/ContactCenter.vue";
import ContactUs from "./contactItem/ContactUs.vue";
import ContactDown from "./contactItem/ContactDown.vue";

export default {
  name: "ContactHome",
  components: {
    ContactMap,
    ContactCenter,
    ContactUs,
    ContactDown
  },
};
</script>

<style scoped>
.top-img {
  width: 100%;
  height: 60vh;
  overflow: hidden;
}

.top-img img {
  width: 100%;
  height: 110%;
  object-fit: cover;
  object-position: bottom;
  display: block;
}

.aboutexhibit-title-top {
  height: 5px;
  background-color: #018fd7;
  margin: 0 48vw;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-top: 100px;
}

.aboutexhibit-title-text h1 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/contact/ContactHome.vue